﻿module PortalLibs.Shared.Boolean

  let toYesNoString bool =
    match bool with
    | false -> "No"
    | true -> "Yes"

  let toYesNoStringOpt boolOpt =
    match boolOpt with
    | None -> ""
    | Some v -> toYesNoString v